/* eslint-disable
    camelcase,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import EnzymeListRowTemplate from 'profile/EnzymeListRowTemplate';
import EnzymeRowTemplate from 'profile/EnzymeRowTemplate';
import OwnablesManageView from 'profile/OwnablesManageView';
import Enzymes from 'molbio/enzymes/backbone/Enzymes';
import EnzymeList from 'molbio/enzymes/backbone/EnzymeList';
import notifications from 'notifications';
import * as analytics from 'analytics/Analytics';

class EnzymeListRow extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'tr';
    this.prototype.className = 'enzyme-row';
    this.prototype.template = EnzymeListRowTemplate;
    this.prototype.events = {'click .close': 'unselect'};
  }

  initialize({writable}) {
    this.writable = writable;
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
  }

  unselect() {
    return this.model.set({active: false});
  }

  render() {
    this.$el.html(this.template({enzyme: this.model, writable: this.writable}));
    return this;
  }
}
EnzymeListRow.initClass();

class CommonEnzymeRowView extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'tr';
    this.prototype.className = 'enzyme-row';
    this.prototype.template = EnzymeRowTemplate;
    this.prototype.events = {click: 'selectEnzyme'};
  }

  initialize() {
    this.listenTo(this.model, 'change:active', this.render);
    return this.listenTo(this.model, 'change:catalogVisible', this.render);
  }

  selectEnzyme() {
    return this.model.set({active: !this.model.get('active')});
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
  }

  render() {
    if (!this.model.get('catalogVisible')) {
      this.$el.addClass('hidden');
      return this;
    }
    this.$el.removeClass('hidden');
    this.$el.html(this.template({enzyme: this.model}));
    if (this.model.get('active')) {
      this.$el.addClass('active');
    } else {
      this.$el.removeClass('active');
    }
    return this;
  }
}
CommonEnzymeRowView.initClass();

class EnzymeListContentView extends Backbone.View {
  static initClass() {
    this.prototype.el = '.enzyme-list-table tbody';
  }

  initialize({enzymes}) {
    this.enzymes = enzymes;
    this.listenTo(this.enzymes, 'change:active', this.render);
    return this.listenTo(this.enzymes, 'inventoryChange', this.render);
  }

  update(list) {
    return (this.list = list);
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
    if (this.itemViews != null) {
      for (const view of Array.from(this.itemViews)) {
        view.die();
      }
    }
  }

  render() {
    if (this.itemViews != null) {
      for (const view of Array.from(this.itemViews)) {
        view.die();
      }
    }

    const models = this.enzymes.filter((enzyme) => enzyme.get('active'));
    const {writable} = this.list.get('permissions');
    // eslint-disable-next-line no-restricted-syntax
    this.itemViews = _.map(models, (enzyme) =>
      new EnzymeListRow({
        model: enzyme,
        writable,
      }).render()
    );
    // eslint-disable-next-line no-restricted-syntax
    const els = _.map(this.itemViews, (view) => view.el);
    if (els.length > 0) {
      this.$el.html(els);
    } else {
      let help;
      if (writable) {
        help = $('<p>').html('<em>This list is empty - add enzymes by clicking on them from the right.</em>');
      } else {
        help = $('<p>').html('<em>This list is empty.</em>');
      }
      this.$el.html(help);
    }
    return this;
  }
}
EnzymeListContentView.initClass();

class CommonEnzymesView extends Backbone.View {
  static initClass() {
    this.prototype.el = '.common-enzymes-table tbody';
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
    if (this.itemViews != null) {
      for (const view of Array.from(this.itemViews)) {
        view.die();
      }
    }
  }

  render() {
    if (this.itemViews != null) {
      for (const view of Array.from(this.itemViews)) {
        view.die();
      }
    }
    this.itemViews = this.model.map((enzyme) => new CommonEnzymeRowView({model: enzyme}).render());
    const els = this.itemViews.map((view) => view.el);
    this.$el.html(els);
    return this;
  }
}
CommonEnzymesView.initClass();

class EnzymeLists extends Backbone.Collection {
  static initClass() {
    this.prototype.model = EnzymeList;
  }
}
EnzymeLists.initClass();

let enzymeListsCollection = null;

class EnzymeListsView extends OwnablesManageView {
  static initClass() {
    this.prototype.el = '.js-enzyme-lists';
    this.prototype.type = 'enzyme-lists';
    this.prototype.modelType = ModelTypeConstants.ENZYME_LIST;
  }
  events() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.events(), {
      'change .search': 'filter',
      'keyup .search': 'filter',
      'submit .create-new form': 'createNewList',
      'click .save-enzymes': 'saveEnzymes',
    });
  }

  static getBootstrappedOwnables() {
    if (enzymeListsCollection == null) {
      enzymeListsCollection = new EnzymeLists(window.bootstrap.enzyme_lists, {parse: true});
    }
    return enzymeListsCollection;
  }

  initialize(options) {
    this.enzymes = Enzymes.getCommonEnzymes();
    this.enzymeContent = new EnzymeListContentView({enzymes: this.enzymes});
    this.commonEnzymes = new CommonEnzymesView({model: this.enzymes});
    super.initialize(options);
  }

  die() {
    super.die();
    this.enzymeContent.die();
    this.commonEnzymes.die();
  }

  saveEnzymes() {
    this.$('.save-enzymes').addClass('disabled');
    return this.currentOwnable
      .save(
        {members: Array.from(this.enzymes.where({active: true})).map((enzyme) => enzyme.id)},
        {patch: true, url: `${this.currentOwnable.url()}/attributes`}
      )
      .always(() => this.$('.save-enzymes').removeClass('disabled'))
      .done(() => notifications.success('Enzyme list successfully updated.'))
      .fail(notifications.notifyError);
  }

  filter() {
    const parts = this.$el.find('.search').val().split(' ');
    return this.enzymes.each((enzyme) => {
      let searchVisible = true;
      const name = enzyme.get('name').toLowerCase();
      for (const part of Array.from(parts)) {
        searchVisible = searchVisible && name.indexOf(part.toLowerCase()) >= 0;
      }

      return enzyme.set('catalogVisible', searchVisible);
    });
  }

  createNewList(e) {
    e.preventDefault();
    const list = new EnzymeList({
      name: this.$el.find('.create-new .name').val(),
      description: this.$el.find('.create-new .description').val(),
      owner_id: window.bootstrap.current_entity_id,
    });
    return list
      .save()
      .done(
        // eslint-disable-next-line no-restricted-syntax
        _.bind(function () {
          this.$el.find('.create-new .name, .create-new .description').val('');
          this.ownables.add(list);
          this.navigateToOwnable(list.id);
          notifications.success('List created successfully!');
          return analytics.track('DATA_MANAGEMENT', 'created_ownable', {
            type: this.type,
            name: list.get('name'),
            has_description: list.get('description').length > 0,
          });
        }, this)
      )
      .fail(notifications.notifyError);
  }

  renderOwnable() {
    let enzyme;
    super.renderOwnable();
    const list = this.currentOwnable;
    this.enzymeContent.update(list);
    const enzyme_ids = (() => {
      const result = [];
      for (enzyme of Array.from(list.get('members'))) {
        result.push(enzyme.id);
      }
      return result;
    })();
    for (enzyme of Array.from(this.enzymes.models)) {
      enzyme.set({active: Array.from(enzyme_ids).includes(enzyme.id)}, {silent: true});
    }
    this.enzymes.trigger('inventoryChange');

    this.commonEnzymes.render();
    this.$el.find('.common-enzymes-disabled').toggleClass('hidden', list.get('permissions').writable);
    this.$el.find('.save-enzymes').toggleClass('hidden', !list.get('permissions').writable);

    $.getJSON(`/1/api/enzyme-lists/${list.id}/collaborators/`)
      .done((res) => this.createCollaboratorsView(res))
      .fail(notifications.notifyError);
  }
}
EnzymeListsView.initClass();

export default EnzymeListsView;
